export const initialMarketChartResponse = {
  collection: [],
  showVolume: false,
};
